import type { SvgIconProps } from 'types/icon';
import ArrowBack from '@mui/icons-material/ArrowBack';

export const ArrowBackIcon = ({
  color = 'inherit',
  ...props
}: SvgIconProps) => <ArrowBack color={color} {...props} />;
